import { AccountInfo } from '@azure/msal-browser'
import Vue from 'vue'
import Vuex from 'vuex';
import * as types from "@/types";
import { UserInfo } from '@/auth/AuthModule';

Vue.use(Vuex)

export default new Vuex.Store<AppState>({
    state: {
        account: null,
        isLoggedIn: false,
        appSettings: null,
        profile: null
    },
    mutations: {
        ["SET_ACCOUNT"](state, payload) {
            state.account = payload;
            state.isLoggedIn = true;
        },
        ["SET_PROFILE"](state, payload) {
            state.profile = payload;
        },
        ["LOGOUT"](state) {
            state.account = null;
            state.isLoggedIn = false;
        },
        ["SET_APP_SETTINGS"](state: AppState, payload: types.AppSettings) {
            state.appSettings = payload;
        },
    },
    actions: {
        ["LOGOUT"](context) {
            context.commit("LOGOUT");
        }
    },
    modules: {
    },
    getters: {
        account(state: AppState): AccountInfo | null {
            return state.account;
        },
        profile(state: AppState): UserInfo|null{
            return state.profile;
        },
        isLoggedIn(state: AppState): boolean {
            return !!state.account;
        },
        appSettings(state: AppState): types.AppSettings | null {
            return state.appSettings;
        }
    }
})

interface AppState {
    account: AccountInfo | null;
    isLoggedIn: boolean;
    appSettings: types.AppSettings | null;
    profile: UserInfo | null;
}
